/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfFeedbackDetailDto } from '../../models/platform-api-result-of-feedback-detail-dto';

export interface GetFeedbackMineId$Params {
  id: string;
}

export function getFeedbackMineId(http: HttpClient, rootUrl: string, params: GetFeedbackMineId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
  const rb = new RequestBuilder(rootUrl, getFeedbackMineId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>;
    })
  );
}

getFeedbackMineId.PATH = '/api/feedback/mine/{id}';
